import { Avatar, StatusBadge } from "components/core";
import { CEWP_USER_STATUS_BADGE_OPTIONS } from "components/forms/cewp-user/schema";
import moment from "moment";
import { FC } from "react";

export interface CewpUserViewProps {
  user: {
    _id?: string;
    code?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    emailAddress?: string;
    certificationNumber?: string;
    status?: string;
    profileImageUrl?: string;
    districts?: { _id: string; code?: string; name?: string }[];
    partner?: { _id: string; code?: string; name?: string };
    createdAt?: string;
    updatedAt?: string;
    suspendedAt?: string;
    deletedAt?: string;
  };
}

export const CewpUserView: FC<CewpUserViewProps> = ({ user }) => {
  const fullName = [
    (user?.lastName || "")?.trim(),
    (user?.firstName || "")?.trim(),
  ]
    .join(" ")
    .trim();

  const districtNames =
    user?.districts?.map((d) => d.name || d.code).filter(Boolean).join(", ") ||
    "N/A";

  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div className="grid grid-cols-3 gap-6">
        <div className="row-span-2 flex flex-col space-y-3 items-center justify-center">
          <Avatar
            alt={fullName || "N/A"}
            src={user?.profileImageUrl || ""}
            size="xl"
          />
          <StatusBadge
            status={user?.status || ""}
            options={CEWP_USER_STATUS_BADGE_OPTIONS}
          />
        </div>
        <div>
          <p className="text-xs font-light text-gray-500">Code</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {user?.code || "N/A"}
          </p>
        </div>
        <div>
          <p className="text-xs font-light text-gray-500">Certification Number</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {user?.certificationNumber || "N/A"}
          </p>
        </div>
        <div>
          <p className="text-xs font-light text-gray-500">Last Name</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {user?.lastName || "N/A"}
          </p>
        </div>
        <div>
          <p className="text-xs font-light text-gray-500">Other Names</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {user?.firstName || "N/A"}
          </p>
        </div>
        <div>
          <p className="text-xs font-light text-gray-500">Phone Number</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {user?.phoneNumber || "N/A"}
          </p>
        </div>
        <div>
          <p className="text-xs font-light text-gray-500">Email Address</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {user?.emailAddress || "N/A"}
          </p>
        </div>
        <div className="col-span-2">
          <p className="text-xs font-light text-gray-500">Districts</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {districtNames}
          </p>
        </div>
      </div>

      {user?.status === "Suspended" && user?.suspendedAt && (
        <div className="pt-6">
          <p className="text-xs font-light text-gray-500">Suspended At</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {moment(user.suspendedAt).format("DD/MM/YYYY [at] hh:mm A")}
          </p>
        </div>
      )}

      {user?.status === "Deleted" && user?.deletedAt && (
        <div className="pt-6">
          <p className="text-xs font-light text-gray-500">Deleted At</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {moment(user.deletedAt).format("DD/MM/YYYY [at] hh:mm A")}
          </p>
        </div>
      )}

      <div className="pt-6 grid grid-cols-2 gap-6">
        <div>
          <p className="text-xs font-light text-gray-500">Created At</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {user?.createdAt
              ? moment(user.createdAt).format("DD/MM/YYYY [at] hh:mm A")
              : "N/A"}
          </p>
        </div>
        <div>
          <p className="text-xs font-light text-gray-500">Updated At</p>
          <p className="mt-1 text-sm text-gray-900 dark:text-gray-100">
            {user?.updatedAt
              ? moment(user.updatedAt).format("DD/MM/YYYY [at] hh:mm A")
              : "N/A"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CewpUserView;
